import React, { useState, useEffect } from "react";
import Header from "../Components/Visit/Header";
import VisitOverview from "../Components/Visit/VisitOverview";
import { getVisit } from "../actions/VisitAction";

const Visit = () => {
  const [data, setData] = useState([]);
  const [stats, setStats] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const fetchData = async () => {
    const response = await getVisit(searchTerm,currentPage, itemsPerPage);
    console.log("response", response);
    if (response.success) {
      setData(response.data);
      setStats(response.stats);
      setCurrentPage(response.currentPage);
      setTotalCount(response.totalCount);
      setTotalPages(response.totalPages);
    }
  };
  useEffect(() => {
    fetchData();
  }, [currentPage,itemsPerPage,searchTerm]);
  return (
    <div>
      <Header stats={stats} />
      <VisitOverview
        data={data}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        setCurrentPage={setCurrentPage}
        setSearchTerm={setSearchTerm}
        setItemsPerPage={setItemsPerPage}
        itemsPerPage={itemsPerPage }
      />
    </div>
  );
};

export default Visit;
